import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { ArrowDownIcon, ArrowUpIcon } from '@edusynch/edusynch-svg-icons';
import * as S from './SidebarUnclickableLink.style';

const SidebarUnclickableLink = ({
  onClick,
  isDesktop,
  activeMenuName,
  disabled,
  Icon,
  name,
  expanded,
  isExpandedInline,
  onMobileSubmenuToggle,
}) => {
  const translatedName = i18n.t(
    `sidebar.${name?.replaceAll(' ', '-').toLowerCase()}`
  );
  const isActive = activeMenuName === name;

  const handleClick = (e) => {
    e.preventDefault();
    if (expanded || !isDesktop) {
      if (onMobileSubmenuToggle) {
        onMobileSubmenuToggle(name);
      }
    } else {
      onClick(e);
    }
  };

  return (
    <S.MenuItem
      onClick={handleClick}
      type="button"
      className={
        isActive || isExpandedInline
          ? 'anchor-element active'
          : 'anchor-element'
      }
      data-name={name}
      disabled={disabled}
      data-tooltip-id="sidebar-tooltip"
      data-tooltip-content={translatedName}
      $expanded={expanded}
    >
      <S.IconWrapper>
        <Icon color="currentColor" width={24} height={24} />
      </S.IconWrapper>
      {(expanded || !isDesktop) && <S.Label>{translatedName}</S.Label>}
      {(expanded || !isDesktop) && (
        <S.ChevronWrapper $active={isActive || isExpandedInline}>
          {isExpandedInline ? (
            <ArrowUpIcon width={16} height={16} color="#0075EA" />
          ) : (
            <ArrowDownIcon width={16} height={16} color="#F2F9FF" />
          )}
        </S.ChevronWrapper>
      )}
    </S.MenuItem>
  );
};

SidebarUnclickableLink.propTypes = {
  onClick: PropTypes.func,
  activeMenuName: PropTypes.string,
  Icon: PropTypes.func,
  name: PropTypes.string,
  isDesktop: PropTypes.bool,
  expanded: PropTypes.bool,
  isExpandedInline: PropTypes.bool,
  onMobileSubmenuToggle: PropTypes.func,
  disabled: PropTypes.bool,
};

SidebarUnclickableLink.defaultProps = {
  expanded: true,
  isExpandedInline: false,
};

export default SidebarUnclickableLink;
